module.exports = __webpack_public_path__ + "static/media/Computer_hacking.8e61be26.jpg";